import api from './api';

const crmDataProvider = {
    getHistory(params = {}) {
        return api.query('CallManager/history', {
            params
        })
    },
    getLastState() {
        return api.get('CallManager/laststate')
    },
    getContracts(params = {}) {
        return api.query('People/api/People/Contacts', {
            params
        })
    },
    donutReport() {
        return api.get('CallManager/Report/Donat')
    },
    linearReport() {
        return api.get('CallManager/Report/LinearData')
    },
    semicircleReport() {
        return api.get('CallManager/Report/SemiCircleData')
    },
    ProgressBarReport() {
        return api.get('CallManager/Report/ProgressBarsList')
    },
    areaReport() {
        return api.get('CallManager/Report/Area')
    },
    voiceCallLog(params = {}){
        return api.query('CallManager/calllog',{params})
    }

}

export default crmDataProvider